import { ArrowLeft, CheckCircle2, LocateFixed, MessageCircle } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDeliveryLocation } from "../contexts/DeliveryLocationContext";
import { MapPicker } from "../components/MapPicker";

export default function SelectLocation() {
  const navigate = useNavigate();
  const { location, setLocation } = useDeliveryLocation();
  const [locating, setLocating] = useState(false);
  const ready = location?.lat && location?.lng;
  const detect = () => {
    if (!navigator.geolocation) return;
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        setLocation({ lat: coords.latitude, lng: coords.longitude, address: "Current location" });
        setLocating(false);
      },
      () => setLocating(false),
      { enableHighAccuracy: true },
    );
  };
  return (
    <main className="fixed inset-0 z-[1100] bg-white" data-testid="select-location-screen">
      <header className="absolute inset-x-0 top-0 z-10 flex items-center gap-3 bg-white p-3 shadow-sm">
        <button
          type="button"
          onClick={() => navigate(-1)}
          data-testid="location-back"
          className="grid h-10 w-10 place-items-center rounded-full bg-slate-100"
        >
          <ArrowLeft size={18} />
        </button>
        <div>
          <h1 className="font-extrabold">Choose delivery location</h1>
          <p className="text-xs text-slate-500">Drag the map under the pin</p>
        </div>
      </header>
      <div className="h-full pt-16">
        <MapPicker
          value={location}
          onChange={({ lat, lng, address }) => setLocation({ lat, lng, address })}
          height="calc(100vh - 64px)"
        />
      </div>
      <footer className="absolute inset-x-0 bottom-0 z-20 bg-white p-3 shadow-[0_-8px_24px_rgba(0,0,0,0.12)]">
        <p className="mb-2 truncate text-sm font-semibold">
          {location?.address || "Move the map to select your address"}
        </p>
        <button
          type="button"
          onClick={detect}
          data-testid="select-location-gps"
          className="mb-2 flex min-h-10 w-full items-center justify-center gap-2 rounded-lg border border-[#FF5200] text-xs font-bold text-[#FF5200]"
        >
          <LocateFixed size={15} />
          {locating ? "Detecting…" : "Detect Current Location"}
        </button>
        <button
          type="button"
          disabled={!ready}
          onClick={() => navigate(-1)}
          data-testid="set-location-button"
          className="flex min-h-12 w-full items-center justify-center gap-2 rounded-lg bg-[#FF5200] text-sm font-extrabold text-white disabled:opacity-50"
        >
          <CheckCircle2 size={17} />
          Set Location
        </button>
        <a
          href="https://wa.me/917980016662?text=Hamare%20area%20me%20Quick%20Door%20Now%20shuru%20karo!"
          data-testid="location-whatsapp-interest"
          className="mt-2 flex min-h-10 items-center justify-center gap-2 text-xs font-bold text-emerald-700"
        >
          <MessageCircle size={14} />
          Hamare area me Quick Door Now shuru karo! 🚀
        </a>
      </footer>
    </main>
  );
}